import { useState } from 'react';

import { Button, ButtonGroup } from '@/common/components/button';
import { getCookie, setCookie } from '@/shared/cookies';

/**
 * Displays a Cookie Consent dialog that informs the user of Firefly's cookie
 * requirements.
 */
export function CookieConsent() {
  const existingCookie = getCookie('consent');
  const [hasConsented, setHasConsented] = useState(existingCookie === 'yes');

  if (hasConsented) {
    return null;
  }

  const onAccept = () => {
    setCookie('consent', 'yes', {
      maxAge: 31536000, // 1 year
      sameSite: 'strict'
    });
    setHasConsented(true);
  };

  return (
    <div
      className="fixed bottom-0 left-0 w-full box-border z-9999999 rounded-md sm:w-110 sm:left-10 sm:bottom-10"
      tabIndex={0}
      aria-label="Cookie Consent"
      role="region"
    >
      <div
        className="px-6 py-5 border rounded-md bg-white shadow-lg"
        style={{ borderColor: '#F4F4F4' }}
      >
        <div>
          <p className="mb-3 text-xl font-bold" role="heading" aria-level={2}>Cookie Consent</p>
          <div className="text-base">
            <p>
              Cookies are necessary for the functionality of the Member portal/site; by logging in and using the Member portal you are consenting to the use of cookies.
            </p>
            <ButtonGroup align="start">
              <Button aria-label="Accept All" onClick={onAccept}>Accept All</Button>
              <Button href="https://www.talquinelectric.com/privacy-policy/" target="_blank" outline>Privacy Policy</Button>
            </ButtonGroup>
          </div>
        </div>
      </div>
    </div>
  );
}
